import template from './insurance-city-detail.html';
import controller from './insurance-city-detail.controller';

let insuranceCityDetailComponent = {
  bindings: {},
  template,
  controller
};

export default insuranceCityDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/insurance/city/insurance-city-detail.component.js